/**
 * Spec 049/050: how a staff account and a PC's own tools read. Plain functions: the tests run
 * this module as it is.
 */
import type { AccountApp, AccountState, DeviceAbility } from "@/api/accounts";

export const APP_LABEL: Record<AccountApp, string> = {
  google: "Google",
  instagram: "Instagram",
  tiktok: "TikTok",
  youtube: "YouTube",
  x: "X",
  threads: "Threads",
  telegram: "Telegram",
  reddit: "Reddit",
  linkedin: "LinkedIn",
  pinterest: "Pinterest",
  vk: "VK",
};

/** The apps a card may open in its emulator (Google is the emulator's own account). */
export const ANDROID_APPS = (Object.keys(APP_LABEL) as AccountApp[]).filter((a) => a !== "google");

export const STATE_LABEL: Record<AccountState, string> = {
  free: "свободен",
  busy: "занят",
  needs_code: "нужен код",
  maybe_banned: "похоже, забанен",
  banned: "забанен",
  disabled: "выключен",
};

export type Tone = "done" | "waiting" | "needs" | "blocked" | "review";

export function stateTone(state: AccountState): Tone {
  if (state === "free") return "done";
  if (state === "busy") return "review";
  if (state === "needs_code" || state === "maybe_banned") return "needs";
  if (state === "banned") return "blocked";
  return "waiting";
}

/** «занят: «Разведчик Reels» на ПК «Костя» с 14:05». */
export function heldLine(held: { device_name: string | null; since: string } | null, agent: string): string {
  if (!held) return "";
  const at = new Date(held.since).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  return `занят: «${agent}»${held.device_name ? ` на ПК «${held.device_name}»` : ""} с ${at}`;
}

const ABILITY_LABEL: Record<DeviceAbility["state"], string> = {
  ready: "готов",
  installing: "ставится",
  needs_license: "ждёт лицензию",
  needs_virtualization: "нужна виртуализация",
  missing: "не поставлен",
  failed: "не поставился",
  unsupported: "не поддерживается",
};

/** «Android: готов · эмуляторов 2», «Whisper: не поставлен». */
export function abilityLine(name: string, ability: DeviceAbility | null | undefined): string {
  if (!ability) return "";
  const extra = [
    ability.emulators ? `эмуляторов ${ability.emulators}` : null,
    ability.gpu ? "видеокарта" : null,
  ].filter(Boolean);
  return `${name}: ${ABILITY_LABEL[ability.state] ?? ability.state}${extra.length ? ` · ${extra.join(" · ")}` : ""}`;
}
